import React, { useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

const API = "https://ggaarts.onrender.com/api";

const Checkout = () => {
  const { state } = useLocation();
  const items = state?.items || [];
  const art = items[0];
  const total = items.reduce((s, i) => s + i.price, 0);

  const [userName, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");

  const navigate = useNavigate();

  // Razorpay script loader
  const loadScript = (src) =>
    new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });

  const handlePayment = async () => {
    if (!userName || !phone || !email || !address) {
      alert("Fill all details");
      return;
    }

    const loaded = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
    if (!loaded) {
      alert("Razorpay failed to load");
      return;
    }

    const options = {
      key: "rzp_live_SJufQAlMn7W6Qc", 
      amount: total * 100,
      currency: "INR",
      name: "GGA Arts",
      description: art.name,

      handler: async function (response) {
        
        // 1️⃣ Mark artwork SOLD
        await axios.put(`${API}/artworks/${art._id}/sold`);

        // 2️⃣ WhatsApp notification
        const adminPhone = "8904421560";  // ← your WhatsApp number

        const msg =
          `📢 *New Order Received!*\n\n` +
          `👤 *Name:* ${userName}\n` +
          `📞 *Phone:* ${phone}\n` +
          `📧 *Email:* ${email}\n` +
          `🏠 *Address:* ${address}\n\n` +
          `🎨 *Artwork:* ${art.name}\n` +
          `💰 *Amount Paid:* ₹${total}\n` +
          `🧾 *Payment ID:* ${response.razorpay_payment_id}`;

        window.open(`https://wa.me/${adminPhone}?text=${encodeURIComponent(msg)}`);

        alert("Payment Successful! Order Placed.");
        navigate("/");
      },

      prefill: {
        name: userName,
        email,
        contact: phone,
      },

      theme: {
        color: "#d4af37",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
    <div className="checkout-form">
      <h2>Checkout</h2>

      <p className="checkout-total">Total: ₹{total}</p>

      <input className="checkout-input" placeholder="Full Name" value={userName} onChange={(e) => setName(e.target.value)} />
      <input className="checkout-input" placeholder="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} />
      <input className="checkout-input" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <textarea className="checkout-textarea" placeholder="Delivery Address" value={address} onChange={(e) => setAddress(e.target.value)} />

      <button className="checkout-btn" onClick={handlePayment}>
        Pay Securely
      </button>
    </div>
  );
};

export default Checkout;
